import {Component, Input} from '@angular/core';
import {LoaderType, LoaderTypeEnum} from '../../../global/enums/skeleton-loader.enum';
import { NgSwitch, NgSwitchCase, NgIf } from '@angular/common';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

@Component({
    selector: 'slm-skeleton-loader',
    templateUrl: './skeleton-loader.component.html',
    styleUrls: ['./skeleton-loader.component.scss'],
    imports: [NgSwitch, NgSwitchCase, NgIf, NgxSkeletonLoaderComponent]
})
export class SkeletonLoaderComponent {
  public readonly loaderType = LoaderTypeEnum;

  @Input() count = 0;
  @Input() columnCount = 1;
  @Input() type: LoaderType;

  constructor() {}
}
